module.exports = __webpack_public_path__ + "img/gebrateneshuehnerfleischohnehintergrund.e6cc9e98.png";